import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery";

export const leaderboardApi = createApi({
  reducerPath: "leaderboardApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getXpLeaderboard: builder.query({
      query: ({ type, page }: { type: string; page: number }) => ({
        url: `/account/leaderboard/xp?type=${type}&limit=20&offset=${
          page * 20
        }`,
        method: "GET",
      }),
      transformResponse: (response: any) => response.data,
      serializeQueryArgs: ({ queryArgs }) => {
        return queryArgs.type;
      },
      merge: (currentCache, newItems) => {
        return {
          ...newItems,
          leaderboard: [
            ...(currentCache?.leaderboard || []),
            ...(newItems?.leaderboard || []),
          ],
        };
      },
      forceRefetch: ({ currentArg, previousArg }) => {
        return (
          currentArg?.page !== previousArg?.page ||
          currentArg?.type !== previousArg?.type
        );
      },
    }),

    getUserPercentile: builder.query({
      query: (type: string) => ({
        url: `/account/${type}/percentile`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetXpLeaderboardQuery,
  useLazyGetXpLeaderboardQuery,
  useGetUserPercentileQuery,
  useLazyGetUserPercentileQuery,
} = leaderboardApi;
